import { render, staticRenderFns } from "./PostEditorForm.vue?vue&type=template&id=54fb52a6&"
import script from "./PostEditorForm.vue?vue&type=script&lang=js&"
export * from "./PostEditorForm.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostEditorForm.vue"
export default component.exports